module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('messages')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/back.png")
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.messages), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "note1",
      class: {
        'notRead': (item[3] === 'N')
      },
      attrs: {
        "id": index
      }
    }, [_c('img', {
      staticClass: "portrait",
      attrs: {
        "src": item[4]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item[2]))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item[3] === 'N')),
        expression: "(item[3]==='N')"
      }],
      staticClass: "operate",
      on: {
        "click": function($event) {
          _vm.read(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Read')))])])]), _vm._v(" "), _c('hr', {
      staticClass: "small-hr"
    })])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMes),
      expression: "noMes"
    }],
    staticClass: "noMes"
  }, [_vm._v(_vm._s(_vm.$t('noMes')))])], 2), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73328dd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-templates/messages.vue
// module id = 1481
// module chunks = 7